<!--
  [routerLink] directive hijacks the href attribute, so if there is a [routerLink], we can't have a link pointing to the outside.
  Therefore we have to have two separate <a> elements, one for links in SPA scope, one for links pointing to the outside.
 -->
<ng-container *ngIf="nzType === 'link'; else isButton">
  <ng-container *ngIf="outsideURL; else router">
    <a
      nz-button
      [disabled]="disabled"
      [href]="outsideURL"
      [ngClass]="classList"
      [nzDanger]="type === 'warn'"
      [nzLoading]="inProgress"
      [nzType]="nzType">
      <ng-container
        *ngTemplateOutlet="
          content;
          context: { $implicit: label, icon: icon, iconPlacement: iconPlacement, iconKey: iconKey, hasLighterIcon: hasLighterIcon }
        "></ng-container>
    </a>
  </ng-container>

  <ng-template #router>
    <a
      nz-button
      [disabled]="disabled"
      [ngClass]="classList"
      [nzDanger]="type === 'warn'"
      [nzLoading]="inProgress"
      [nzType]="nzType"
      [routerLink]="routerURL">
      <ng-container
        *ngTemplateOutlet="
          content;
          context: { $implicit: label, icon: icon, iconPlacement: iconPlacement, iconKey: iconKey, hasLighterIcon: hasLighterIcon }
        "></ng-container>
    </a>
  </ng-template>
</ng-container>

<ng-template #isButton>
  <button
    nz-button
    [disabled]="disabled"
    [ngClass]="classList"
    [nzDanger]="type === 'warn'"
    [nzLoading]="inProgress"
    [nzType]="nzType">
    <ng-container
      *ngTemplateOutlet="
        content;
        context: { $implicit: label, icon: icon, iconPlacement: iconPlacement, iconKey: iconKey, hasLighterIcon: hasLighterIcon }
      "></ng-container>
  </button>
</ng-template>

<ng-template
  let-hasLighterIcon="hasLighterIcon"
  let-icon="icon"
  let-iconKey="iconKey"
  let-iconPlacement="iconPlacement"
  let-label
  #content>
  <ui-icon
    class="sh-button-icon"
    *ngIf="icon && iconPlacement === 'left'"
    [key]="iconKey"
    [ngClass]="{ 'sh-lighter-icon': hasLighterIcon }"></ui-icon>
  <ng-container *ngIf="label">{{ label }}</ng-container>
  <ui-icon
    class="sh-button-icon"
    *ngIf="icon && iconPlacement === 'right'"
    [key]="iconKey"
    [ngClass]="{ 'sh-lighter-icon': hasLighterIcon }"></ui-icon>
</ng-template>
